import { useEffect, useState } from 'react';
import { FALLBACK_LANES, fetchLaneOptions, getCachedLanes } from '../lib/lanesApi';

export function useLaneOptions(options?: { initialLanes?: string[]; skipFetch?: boolean }) {
  const cached = getCachedLanes();
  const seeded = options?.initialLanes && options.initialLanes.length > 0 ? options.initialLanes : null;
  const [lanes, setLanes] = useState<string[]>(seeded ?? cached ?? FALLBACK_LANES);
  const [loading, setLoading] = useState(!options?.skipFetch && !seeded && !cached);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let mounted = true;
    if (options?.skipFetch) {
      setLoading(false);
      return () => {
        mounted = false;
      };
    }

    setLoading(true);
    fetchLaneOptions()
      .then((fetched) => {
        if (!mounted) return;
        setLanes(fetched.length ? fetched : FALLBACK_LANES);
        setLoading(false);
      })
      .catch((err) => {
        if (!mounted) return;
        setError(err instanceof Error ? err : new Error('Failed to load lanes'));
        setLanes(FALLBACK_LANES);
        setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [options?.initialLanes, options?.skipFetch]);

  return { lanes, loading, error };
}
